import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/**
 * catalog: W — barcha hamkorlar tovarlari, moderatsiya, kategoriyalar, IKPU;
 * S — hamkor tovarlari, yangi tovar ustasi (6 qadam), tahrirlash.
 */
export const workRoutes: RouteObject[] = [
  { path: 'catalog', ...page(() => import('./pages/WProductsPage')) },
  { path: 'catalog/moderation', ...page(() => import('./pages/WModerationPage')) },
  { path: 'catalog/categories', ...page(() => import('./pages/WCategoriesPage')) },
  { path: 'catalog/ikpu', ...page(() => import('./pages/WIkpuPage')) },
  // Modifikatsiya kartochkasi tovarnikidan OLDIN: `catalog/:id` aks holda uni ham yutib yuborardi.
  { path: 'catalog/skus/:id', ...page(() => import('./pages/WSkuDetailPage')) },
  { path: 'catalog/:id', ...page(() => import('./pages/WProductDetailPage')) },
];

export const sellerRoutes: RouteObject[] = [
  { path: 'products', ...page(() => import('./pages/SProductsPage')) },
  { path: 'products/new', ...page(() => import('./pages/SProductEditorPage')) },
  { path: 'products/:id', ...page(() => import('./pages/SProductEditorPage')) },
];
